<template>
  <div>
    <iModal
      title="发布商机"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="close()"
      :styles="{top: '50px'}"
    >
      <div class="my-modal">
        <div class="my-modal-content">
          <Form ref="formInline" :label-width="100" :model="formInline" :rules="ruleInline">
            <FormItem label="商机图片：">
              <div
                class="my-upload-list"
                v-for="(item, index) in uploadList"
                :key="'upload' + index"
                style="width: 80px;height: 80px;line-height:80px"
              >
                <template v-if="item.status === 'finished'">
                  <img :src="item.url" />
                  <div class="my-upload-list-cover">
                    <Icon
                      type="ios-trash-outline"
                      @click.native.stop.prevent="handleRemoveByArr(item)"
                    ></Icon>
                  </div>
                </template>
                <template v-else>
                  <Spin v-if="item.showProgress" style="width: 80px;height: 80px;">
                    <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                  </Spin>
                </template>
              </div>
              <Upload
                ref="upload"
                :show-upload-list="false"
                :default-file-list="defaultList"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :headers="formHeaders"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                type="drag"
                :action="uploadUrl"
                multiple
                style="display: inline-block;width:80px;"
                v-show="uploadList && uploadList.length < limitNum"
              >
                <div style="width: 80px;height:80px;padding-top: 7px;">
                  <div>
                    +
                    <p>上传</p>
                  </div>
                </div>
                <!-- 蒙版 -->
                <div
                  style="position:absolute;opacity:0;width:80px;height:80px;left:0;top:0;background-color:red;"
                  @click.stop="selectType"
                ></div>
              </Upload>
              <p 
                class="upload-p"
                style="display: block;"
              >(图片要求：2M以下的jpg或png)</p>
            </FormItem>
            <FormItem label="商机描述：" prop="Introduction">
              <Input type="textarea" :rows="8" v-model="formInline.Introduction" />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">发布</Button>
        <Button @click="close()">取消</Button>
      </div>
    </iModal>
    <iModal title="图片查看" cancel-text v-model="visible" :z-index="10002">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
    <!-- 选择文件上传方式 -->
    <uploadChoose
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      fileType="img"
      :maxCount="5"
      v-model="uploadChooseShowed"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import uploadChoose from "@components/uploadChoose/uploadChoose";
export default {
  name: "add-release",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      showModal: false,
      formInline: {
        Introduction: ""
      },
      ruleInline: {
        // 效验规则
        Introduction: [
          { required: true, message: "必填选项", trigger: "blur" },
          {
            type: "string",
            max: 200,
            message: "商机描述文字说明不能大于200字",
            trigger: "blur"
          }
        ]
      },
      uploadList: [],
      defaultList: [],
      visible: false,
      limitNum: 5, // 图片上传限制
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    })
  },
  methods: {
    ...mapActions({
      addRelease: "releaseModule/addRelease"
    }),
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`Incorrect file format, Upload image in jpg/png format`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`File size exceeds configured limit, Upload image size less than 2M`);
    },
    handleBeforeUpload() {
      const check = this.$refs.upload.fileList.length < this.limitNum;
      if (!check) {
        this.$Message.warning(`Upload ${this.limitNum} image only`);
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let imgList = this.transfromImgList(this.uploadList);
      let valid = await this.validForm(name);
      if (!valid) return;
      let formData = {
        AgentId: this.company.agentId,
        FromType: 0,
        FromId: this.company.id,
        Photo: imgList,
        Information: this.formInline.Introduction
      }; 
      this.loading = true;
      let bool = await this.addRelease(formData);
      this.loading = false;
      if (bool.successed) {
        this.$Message.success("新建成功");
        this.$emit("finish");
        this.close();
      } else {
        this.$Message.error("新建失败，请重新尝试");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    close() {
      this.loading = false;
      this.uploadList = [];
      this.defaultList = [];
      this.visible = false;
      this.$refs.upload.clearFiles();
      if (this.$refs.upload2) {
        this.$refs.upload2.clearFiles();
      }
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      this.$emit("close");
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if(this.uploadList.length >= 5) {
          this.$Message.warning(`Upload 5 image only`);
          return
        } else {
          this.uploadList.push({
          status: "finished",
          url: item
        });
        }
      }
    },
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList;
  },
  components: {
    uploadChoose
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}
</style>